const utils = {};

export default utils;

export const Http = {
  createError(error, callingFunction, data) {
    return {
      callingFunction,
      error,
      data,
    };
  },
  setGlobalError(context, data) {
    /* eslint-disable no-param-reassign */
    context.rootState.Http.error = data;
  },
  requests: 0,
};
